import { Snackbar as MuiSnackbar } from "@mui/material";

type Props = {
  open: boolean;
  message?: string;
  onClose: () => void;
  autoHideDuration?: number;
};

export function Snackbar({
  open,
  message,
  onClose,
  autoHideDuration = 3000,
}: Props) {
  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={autoHideDuration}
      message={message}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{
        bottom:
          "calc(env(safe-area-inset-bottom) + var(--footer-height) + (var(--spacing) * 4))",
      }}
    />
  );
}
